import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from 'modules/AdminService';
import _notification from 'modules/notification';
import { Card, Modal } from 'antd';
import ConfirmPopup from '../popup/ConfirmPopup';
import { GENERAL_ERROR_MESSAGE } from '../../constants/constants';
import PageHeader from 'components/enterprise/PageHeader';
import { routesAdmin } from 'routes/Routes';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';


class SendBulkViewResultEmail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showConfirmPopup: false
        };
    }

    handleConfirmPopup = () => {
        this.setState({
            showConfirmPopup: true
        })
    }

    closeMessageBox(value = false) {
        this.setState({ showConfirmPopup: value });
    }

    //Message box confirm delete click
    onConfirmDelete = async () => {
        this.setState({ loading: true }, async () => {

            try {
                const response = await _AdminService.SendBulkEmailForViewResultEmail();

                const data = response.data;
                if (data.IsSuccess == true) {
                    _notification.showMessage('success', "Email will send");
                    this.setState({
                        loading: false,
                        showConfirmPopup: false
                    });
                }
                else {
                    _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                    this.setState({
                        loading: false,
                        showConfirmPopup: false
                    });
                }
            } catch (error) {
                this.setState({
                    loading: false,
                    showConfirmPopup: false
                });
                console.log('Error: ', error);
                _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
            }
        });
    }

    render() {
        if (this.state.loading)
            return <LoadingSpinner/>

        return (
    
        <div className="container-fluid p-3">
            <PageHeader
                title="Send View Result Email"
                breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Communications' }, { label: 'Send View Result Email' }]}
            />
            <div className="max1200 m-auto">
                <div className="ent-panel mb-3">
                    
                    <div className="admin-inner-wrap p-3"> 
                        <h5 className="heading5 text-center">Click on Send button to send bulk View Result Email</h5>
                    </div>
                    <div className="pt-4 text-center" >
                        <button type="button" onClick={this.handleConfirmPopup} className="button-global button-primary autoHeight autoWidth"><span>Send</span></button>
                    </div>
                </div>


            </div> 
            <Modal
                centered={true}
                width={500}
                className="modelPopAnt admin-home"
                visible={this.state.showConfirmPopup}
                onCancel={() => this.closeMessageBox(false)}
                footer={false}
            >
                <ConfirmPopup
                    onCancel={() => this.closeMessageBox(false)}
                    onOk={this.onConfirmDelete}
                    message="Are you sure, you want to send bulk View Result Email?"
                />
            </Modal>
        </div>

        )

    }
}

export default SendBulkViewResultEmail;